import React from 'react';
import { BaseSection } from '../../components/BaseSection';
import { Box, BoxProps, Flex, Heading, Text } from '@chakra-ui/react';
import SubscriptionBox, {
    SubscriptionBoxProps,
} from '../../components/SubscriptionBox/SubscriptionBox'; // Import the SubscriptionBox component
import StyledButton from '../../components/Button/Button';
import { StyledContainer } from '../HeroSection/styles';

import { buttonVariant } from '../../types/buttonTypes';
import { StyledHeading } from '../TilesSection/styles';

interface SubscriptionSectionProps extends BoxProps {
    title?: string;
    subtitle?: string;
    subscriptionsInfo?: SubscriptionBoxProps[];
    buttons?: {
        title: string;
        href: string;
        variant: buttonVariant;
    }[];
}

const titleDefault = 'Dostępne plany abonamentowe';
const subtitleDefault =
    'Dopasuj plan do swoich indywidualnych potrzeb, dzięki czemu zaoszczędzisz na kosztach prowadzenia sklepu.';
const subscriptionsInfoDefault: SubscriptionBoxProps[] = [
    {
        name: 'Start',
        text: 'Optymalny dla małych biznesów - rozpocznij sprzedaż z IdoSell!',
        // limitText: 'Do 20 zamówień miesięcznie',
        previousPrice: '109 zł',
        currentPrice: '29 zł',
        textBelowPrice: '/netto miesięcznie - płatność jednorazowa za rok',
    },
    {
        name: 'Business',
        text: 'Optymalny dla średnich biznesów - rozwij z nami skrzydła!',
        // limitText: 'Do 1 000 zamówień miesięcznie',
        // previousPrice: '249 zł',
        currentPrice: '249 zł',
        textBelowPrice: '/netto miesięcznie',
    },
    {
        name: 'Expert',
        text: 'Optymalny dla średnich i dużych biznesów - jeszcze więcej możliwości',
        // limitText: 'Do 1 000 zamówień miesięcznie',
        // previousPrice: '559 zł',
        currentPrice: '619 zł',
        textBelowPrice: '/netto miesięcznie',
    },
    {
        name: 'Enterprise',
        text: 'Optymalny dla dużych biznesów - zwiększaj z nami sprzedaż',
        // limitText: 'Do 10 000 zamówień miesięcznie',
        // previousPrice: '1899 zł',
        currentPrice: '2099 zł',
        textBelowPrice: '/netto miesięcznie',
    },
    {
        name: 'Individual',
        text: 'Dla wymagających – wiele możliwości elastycznego dostosowania rozwiązań',
        // limitText: 'Powyżej 10 tys. zamówień miesięcznie',
        previousPrice: '',
        currentPrice: 'Do negocjacji',
        textBelowPrice: '',
    },
];

const buttonsDefault: {
    title: string;
    href: string;
    variant: buttonVariant;
}[] = [
    {
        title: 'Zamów sklep',
        href: 'https://www.idosell.com/pl/abonamenty/',
        variant: 'default',
    },
    {
        title: 'Umów się na spotkanie',
        href: 'https://eu1.hubs.ly/H08swyQ0',
        variant: 'outline',
    },
];

const SubscriptionSection: React.FC<SubscriptionSectionProps> = ({
    title = titleDefault,
    subtitle = subtitleDefault,
    subscriptionsInfo = subscriptionsInfoDefault,
    buttons = buttonsDefault,
    ...props
}) => {
    return (
        <Box {...props}>
            <Flex alignItems="center" flexDirection="column" className="text-main" mb={8}>
                {/* <Heading as={'h2'} textAlign="center" fontWeight={'600'}>
                    {title}
                </Heading> */}
                <StyledHeading>{title}</StyledHeading>
                <Text textAlign="center" fontSize="lg">
                    {subtitle}
                </Text>
            </Flex>
            <Flex w={'100%'} flexWrap={'wrap'} gap={'20px'}>
                {subscriptionsInfo.map((subscription, index) => (
                    <Box
                        backgroundColor={'red'}
                        w={{
                            base: '100%',
                            md: 'calc(50% - 20px / 2)',
                            xl: 'calc(20% - 20px * 4 / 5)',
                        }}
                    >
                        <SubscriptionBox key={index} {...subscription} />
                    </Box>
                ))}
            </Flex>
            <Flex
                mt={8}
                justifyContent={'center'}
                gap={{
                    base: 6,
                    md: 10,
                }}
                flexWrap={'wrap'}
            >
                {buttons?.map(button => {
                    return (
                        <StyledButton href={button.href} style={button.variant} target="_blank">
                            {button.title}
                        </StyledButton>
                    );
                })}
            </Flex>
        </Box>
    );
};

export default SubscriptionSection;
